module.exports = __webpack_public_path__ + "static/XD16-784040f96b3d0888333467779860a803.jpg";